import { Injectable, Injector } from '@angular/core';

import { PopularBetsConfig, SitecorePopularBetsConfig } from '@frontend/sports/common/client-config-data-access';
import { WidgetType } from '@frontend/sports/types/components/widget';
import { OnFeatureInit } from '@frontend/vanilla/core';
import { combineLatest, firstValueFrom } from 'rxjs';

import { WidgetRegistryService } from '../../widget/core/widget-registry.service';
import { PopularMultiBetsWidgetComponent } from './popular-multi-bets-widget.component';

@Injectable({ providedIn: 'root' })
export class PopularMultiBetsWidgetRegistration implements OnFeatureInit {
    constructor(
        private widgetRegistry: WidgetRegistryService,
        private injector: Injector,
        private sitecorePopularBetsConfig: SitecorePopularBetsConfig,
        private popularBetsConfig: PopularBetsConfig,
    ) {}

    async onFeatureInit(): Promise<void> {
        await firstValueFrom(combineLatest([this.sitecorePopularBetsConfig.whenReady, this.popularBetsConfig.whenReady]));
        this.widgetRegistry.registerLazy(WidgetType.PopularMultiBets, PopularMultiBetsWidgetComponent, this.injector);
    }
}
